<button [ngStyle]="theme" class="paybee-button--embedded subtitle-2--embedded-typography">{{text}}</button>